'use client';

import { Trans } from '@lingui/macro';
import { Stack } from '@mui/material';
import { Button } from '@prismo-io/design-system';
import { type FC, type ReactNode, useState } from 'react';

type Item = {
  id: string;
  render: ReactNode;
  defaultVisibility: boolean;
};

type Props = {
  list: Item[];
};

export const ValuesListHideWrapper: FC<Props> = (props) => {
  const { list } = props;

  const [wantToSeeMore, setWantToSeeMore] = useState<boolean>(false);

  const onToggleWantToSeeMore = () => {
    setWantToSeeMore(!wantToSeeMore);
  };

  return (
    <Stack direction="column" flexWrap="wrap" spacing={3}>
      {list
        .filter((item) => item.defaultVisibility || wantToSeeMore)
        .map((item) => (
          <>{item.render}</>
        ))}

      <Stack direction="row" justifyContent="center">
        <Button onClick={onToggleWantToSeeMore} variant="text" color="inherit">
          {wantToSeeMore ? (
            <Trans>Cacher une partie de la hiérarchie</Trans>
          ) : (
            <Trans>Afficher toute la hiérarchie</Trans>
          )}
        </Button>
      </Stack>
    </Stack>
  );
};
